import React, {useEffect, useRef, useState} from 'react';
import API from "../utils/API";
import Error from "./Error";
import Forms from "./Forms";
import {useTranslation} from 'react-i18next';
import {API_ENDPOINTS} from "../apiConfig";

const RepairCatalogModal = ({close, onRepairUpdate, catalogRepair}) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [discount, setDiscount] = useState('');
    const [timeRequirement, setTimeRequirement] = useState('');
    const [error, setError] = useState('');
    const {t} = useTranslation();
    const inputRef = useRef(null);

    useEffect(() => {
        setName(catalogRepair ? catalogRepair.name : '');
        setDescription(catalogRepair ? catalogRepair.description : '');
        setDiscount(catalogRepair?.discount ? catalogRepair.discount : '');
        setTimeRequirement(catalogRepair?.timeRequirement ?? '');
    }, [catalogRepair]);

    useEffect(() => {
        setTimeout(() => {
            inputRef.current.focus();
        }, 0);
    }, []);

    const handleSubmit = async (e) => {
        e?.preventDefault();
        setError();
        try {
            if (catalogRepair) {
                await API.put(API_ENDPOINTS.repairCatalog.edit(catalogRepair._id), {
                    name,
                    description,
                    discount,
                    timeRequirement: timeRequirement === '' ? null : Number(timeRequirement)
                });
            } else {
                await API.post(API_ENDPOINTS.repairCatalog.add, {
                    name,
                    description,
                    discount,
                    timeRequirement: timeRequirement === '' ? null : Number(timeRequirement)
                });
            }
            onRepairUpdate();
            close();
        } catch (error) {
            setError(error);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <Forms.Text
                required
                ref={inputRef}
                placeholder="Název"
                value={name}
                onChange={(val) => setName(val)}
                className="rounded-t-md"
            />
            <Forms.Textarea
                required
                placeholder="Popis"
                value={description}
                onChange={(val) => setDescription(val)}
                className="rounded-b-md"
            />
            <Forms.Number
                required
                placeholder="Globální sleva"
                value={discount}
                onChange={(val) => setDiscount(val)}
                className="rounded-b-md"
            />
            <Forms.Number
                placeholder="Výchozí čas (min)"
                value={timeRequirement}
                onChange={(val) => setTimeRequirement(val)}
                min={0}
                step={1}
                className="rounded-b-md"
            />
            {error && <Error error={error}/>}
            <Forms.Button onClick={handleSubmit}
                          label={catalogRepair ? t('update') : t('save')}
                          className="mt-4"/>
        </form>
    );
};

export default RepairCatalogModal;
